export const errorStyles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    color: "white.main",
  },
  text: {
    fontSize: "0.75rem",
    lineHeight: "1.625em",
    pr: "0.56rem",
  },
};
